import { Box } from '@vp/swan';
import styled from 'styled-components';

const StepDescriptionBox = styled(Box)`
    max-width: 262px;
`;

export default StepDescriptionBox;
